import script from "./languageComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./languageComponent.vue?vue&type=script&setup=true&lang=js"

import "./languageComponent.vue?vue&type=style&index=0&id=676e5560&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-676e5560"]])

export default __exports__